import { IconName } from "@blueprintjs/core";
import { Registry } from "react-registry";

import Logger from "core/util/Logger";


/**
 * configuration data created with {@link ./LayoutField.tsx} and rendered by {@link Layout.tsx}.
 */
export interface ILayout<T = any> {

	// key for the default layout. automatically set to the first layout option added.
	layoutKey: string;

	// conditional overrides for the default layout.
	// so far, only supports breakpoints. maybe add other things in the future?
	overrides?: Array<{
		breakpoint: number;
		layoutKey: string;
	}>;

	// layout configurations. first one added will automatically be set to default.
	layouts: {
		[layoutKey: string]: { // auto generated
			__editName: string; // display name for this layout configuration. e.g. "Desktop", "Mobile"
			type: string;
			config: any; // based on selected type
		}
	};

	// region data passed to Layout component's renderRegion method
	regions: {
		[regionUuid: string]: { // auto generated
			__editName: string;
			data: T;
		};
	};
}

/**
 * layout type definition that provides editing interfaces and rendering.
 */
export interface ILayoutType<D extends object = {}> {
	// registered id
	type: string;

	// display name
	label: string;

	// display icon for edit menus
	icon?: IconName;

	// form field for editing this layout type's data
	renderInput: (
		data: D,
		onChange: (data: D) => void,
		regions: { [uuid: string]: { __editName: string; }; }
	) => JSX.Element;

	// preview for editor
	renderPreview?: (data: D, regions: { [uuid: string]: { __editName: string; }; }) => JSX.Element;

	// how the layout renders in the front end
	renderLayout: (data: D, renderRegion: (uuid: string, index: number) => React.ReactNode, layoutUuid?: string) => JSX.Element;
}

export class LayoutTypeRegistry {

	public static registerType(layoutType: ILayoutType) {
		Registry.register(layoutType, {id: layoutType.type, registry: "__core:layouttype"});
		return layoutType;
	}

	public static getType(type: string): ILayoutType {
		return type ? Registry.get({id: type, registry: "__core:layouttype"}) as ILayoutType : null;
	}

	public static getTypes(types: string[]): ILayoutType[] {
		const res = [];

		for (const type of types) {
			const linkType = this.getType(type);
			if (linkType) {
				res.push(linkType);
			} else {
				Logger.error("INVALID LAYOUT TYPE: %s", type);
			}
		}

		return res;
	}

	public static renderDefaultPreview(data: ILayout) {
		if (!data.layoutKey || !data.layouts[data.layoutKey]) {
			console.log(data.layoutKey, data.layouts);
			return null;
		}

		const sLayout = data.layouts[data.layoutKey];

		const layoutType = this.getType(sLayout.type);

		if (!layoutType) {
			Logger.warn("Invalid layout type: " + layoutType);
			return null;
		}

		return layoutType.renderPreview(sLayout, data.regions);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/fields/layout/ILayoutType.ts